module.exports = "/images/hr.png?789668b61d54c2bdbaf098d633226b25";